import { createApi } from '@/api'
export default {
	getvoluntList: config => createApi( `/volunteer/pageSearch`, 'post', config ),
	voluntDetail: config => createApi(`/volunteer/get`, 'post', config),
	addvolunt: config => createApi(`/volunteer/add`, 'post', config),
	deletevolunt: config => createApi(`/volunteer/delete`, 'delete', config),
	updatevolunt: config => createApi(`/volunteer/update`, 'post', config)
}



// WEBPACK FOOTER //
// ./src/views/postulant/api/index.js